import { useRef, useCallback } from 'react';
import FeatureRow from './FeatureRow';

import styles from '../styles/Section.module.css';

const UserChatsSection = ({ shouldLoad = false, onLoadComplete }) => {
    const loadedCount = useRef(0);
    const totalVideos = 3;

    const handleVideoLoad = useCallback(() => {
        loadedCount.current += 1;
        if (loadedCount.current === totalVideos && onLoadComplete) {
            onLoadComplete();
        }
    }, [onLoadComplete]);

    return (
        <section className={styles.section}>
            <div className={styles.header}>
                <h2 className={styles.sectionTitle}>User Chats</h2>
                <p className={styles.sectionSubtitle}>
                    Experience seamless communication with advanced AI models.
                </p>
            </div>

            <FeatureRow
                title="Chat with Multiple LLMs"
                description="Access a variety of top-tier Large Language Models in one place. Switch between models effortlessly to find the best fit for your specific needs, whether it's coding, creative writing, or analysis."
                videoSrc="https://jetchats.sfo2.cdn.digitaloceanspaces.com/public-videos/demo2/userblock1"
                shouldLoad={shouldLoad}
                onVideoLoad={handleVideoLoad}
            />

            <FeatureRow
                title="External Tools Integration"
                description="Empower your chats with real-world capabilities. Connect to external APIs and tools to fetch data, perform actions, and automate workflows directly within your conversation."
                reversed={true}
                videoSrc="https://jetchats.sfo2.cdn.digitaloceanspaces.com/public-videos/demo2/userblock2"
                shouldLoad={shouldLoad}
                onVideoLoad={handleVideoLoad}
            />

            <FeatureRow
                title="Intelligent Memory"
                description="Never repeat yourself. Our intelligent memory system ensures that context is preserved across conversations, allowing for more natural and continuous interactions."
                videoSrc="https://jetchats.sfo2.cdn.digitaloceanspaces.com/public-videos/demo2/userblock3"
                shouldLoad={shouldLoad}
                onVideoLoad={handleVideoLoad}
            />
        </section>
    );
};

export default UserChatsSection;
